import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../utils/useAuth'; 

const AdminProtectedRoute = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/79834yhbdgyt562xa" replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;